/**
 * Program: Unieuro (Italy)
 * Language: Italian
 * Content: Index for all Italian translations
 */
import cookies from '../../common/it/cookies'
import privacy from '../../common/it/privacy'
import terms from './terms'
import { LangProps } from '../../types'

const it: LangProps = {
  /** -------------------------------------------------------------------------- *
   * Document Titles
   * -------------------------------------------------------------------------- */
  document_title_suffix: 'Dyson Trade In con Alchemy',
  document_title_home: 'Inizia',
  document_title_faq: 'Domande frequenti',
  document_title_quiz: 'Quiz',
  document_title_privacy: 'Informativa sulla privacy',
  document_title_terms: 'Termini e condizioni',
  document_title_cookies: 'Politica sui cookie',
  document_title_backoffice: 'Backoffice',
  document_title_signOut: 'Uscita',
  document_title_notFound: 'Pagina non trovata',
  /** -------------------------------------------------------------------------- *
   * Links
   * -------------------------------------------------------------------------- */
  link_home: 'Home',
  link_tradein: 'Trade In',
  link_faq: 'Domande frequenti',
  link_privacy: 'Informativa sulla privacy',
  link_terms: 'Termini & Condizioni',
  link_cookies: 'Gestione dei Cookie',
  link_cookie_preferences: 'Preferenze sui cookie',
  powered_by: 'Offerto da',
  /** -------------------------------------------------------------------------- *
   * Home
   * -------------------------------------------------------------------------- */
  home_hero_title: 'Permuta il tuo vecchio aspirapolvere e risparmia sul tuo nuovo Dyson',
  home_hero_pretitle: 'Dyson Trade In',
  home_hero_intro:
    'Con Dyson Trade In ti rimborseremo fino a € 150 quando acquisti un aspirapolvere Dyson idoneo e lo permuti con quello vecchio.',
  home_hero_cta: 'Inizia la mia permuta',
  home_hero2_title: 'Grazie per essere interessato',
  home_hero2_intro: 'Sfortunatamente il corrente programma di permuta è chiuso',
  home_hero2_outro:
    'Se hai già completato la richiesta di permuta, assicurati che il prodotto da permuta ci sia stato inviato entro 2 settimane. Si prega di fare riferimento alla nostra email per istruzioni.',
  home_hero2_cta: 'Visita il negozio di Unieuro',
  home_hero_sponsor: 'Offerto da',
  home_steps_title: '3 semplici passi per effettuare la permuta',
  home_step_1_title: 'Verifica se sei idoneo',
  home_step_1_desc:
    "Rispondi al nostro rapido questionario dicendoci quale aspirapolvere vorresti permutare e ti diremo quale sarà l'importo del rimborso.\n\nPer accedere all'offerta devi acquistare un aspirapolvere Dyson Gen5detect™ Absolute o Dyson V15s Detect Submarine™ tra il 22 aprile e il 19 maggio 2024",
  home_step_2_title: 'Inviaci il tuo vecchio aspirapolvere',
  home_step_2_desc:
    "Ti forniremo un'etichetta di spedizione prepagata gratuita.\n\nBasta imballare il vecchio prodotto, attaccare l'etichetta e consegnarlo al punto di consegna DHL più vicino.",
  home_step_3_title: 'Ricevi il rimborso!',
  home_step_3_desc:
    'Una volta ricevuto il tuo vecchio aspirapolvere, emetteremo il pagamento.\n\n Il pagamento verrà effettuato tra i 30 e i 45 giorni dal ricevimento alla nostra struttura e verrà versato sul conto bancario fornitoci.',
  home_steps_cta: 'Comincia la tua permuta',
  home_faq_title: 'Hai domande?',
  home_faq_button: 'Vedi le nostre domande frequenti',
  home_footer_terms:
    "¹ Su Unieuro online, negozi dimostrativi Unieuro selezionati. L'importo del cashback dipende dal dispositivo inviato.",
  /** -------------------------------------------------------------------------- *
   * 404
   * -------------------------------------------------------------------------- */
  not_found_title: '404',
  not_found_desc: 'Impossibile trovare la pagina che stai cercando.',
  not_found_button: 'Torna alla homepage',
  /** -------------------------------------------------------------------------- *
   * FAQ
   * -------------------------------------------------------------------------- */
  faq_hero_title: 'Domande frequenti',
  faq_search_placeholder: 'Tipo di ricerca',
  faq_topics_title: 'Ricerca argomenti',
  faq_search_title: 'Ricerca argomenti',
  faq_search_matches: 'Risultati trovati',
  faq_quick_links_title: 'Salta a',
  // -------------------------------------
  // Application Section
  // -------------------------------------
  faq_topic_1_title: 'Applicare',
  faq_topic_1_q1: 'Dove posso fare la richiesta di permuta Dyson?',
  faq_topic_1_a1: 'Visita https://www.unieuro.it/online/passa-a-dyson per avviare la permuta.',
  faq_topic_1_q2: 'Quali sono i prodotti idonei?',
  faq_topic_1_a2:
    "Per accedere all'offerta di permuta devi acquistare un aspirapolvere Dyson Gen5detect™ Absolute o Dyson V15s Detect Submarine™.",
  faq_topic_1_q3: "Quando si svolge l'evento di permuta?",
  faq_topic_1_a3:
    "L'attività è valida per acquisti effettuati su https://www.unieuro.it, nei negozi Unieuro aderenti o presso l'app unieuro, in Italia tra il 22 aprile e il 19 maggio compresi.\n\n Le richieste devono essere effettuate tramite il portale di permuta entro 14 giorni dall'acquisto",
  faq_topic_1_q4: 'Quali sono i negozi partecipanti?',
  faq_topic_1_a4: `
   Questi sono Unieuro negozi partecipanti alla promozione:.

   - ADRIA, 45011 ADRIA / VENETO
   - AGLIANA, 51031 AGLIANA / TOSCANA
   - AGRIGENTO VILLAGIO MOSE, 92100 AGRIGENTO / SICILIA
   - ALATRI, 03011 ALATRI / LAZIO
   - ALBIGNASEGO, 35020 ALBIGNASEGO / VENETO
   - ALCAMO, 91011 ALCAMO / SICILIA
   - ALMERIA SRL ZUMPANO, 87040 ZUMPANO / CALABRIA
   - ALTAVILLA, 36077 ALTAVILLA VICENTINA / VENETO
   - ANCONA, 60131 ANCONA / MARCHE
   - ANZIO, 00042 ANZIO / LAZIO
   - AOSTA, 11100 AOSTA / VALLE D'AOSTA
   - APRILIA2, 4011 APRILIA / LAZIO
   - AREZZO, 52100 AREZZO / TOSCANA
   - ARICCIA, 00072 ARICCIA / LAZIO
   - ARMA DI TAGGIA, 18011 ARMA DI TAGGIA / LIGURIA
   - ASCOLI, 63100 ASCOLI PICENO / MARCHE
   - ASTI, 14100 ASTI / PIEMONTE
   - AVELLINO, 83042 ATRIPALDA / CAMPANIA
   - BALLÒ DI MIRANO, 30035 BALLO' DI MIRANO / VENETO
   - BARI SANTA CATERINA, 70126 BARI / PUGLIA
   - BELLINZAGO, 20060 BELLINZAGO LOMBARDO / LOMBARDIA
   - BELLUNO, 32100 BELLUNO / VENETO
   - BERGAMO, 24122 BERGAMO / LOMBARDIA
   - BOLOGNA BORGO PANIGALE, 40132 BOLOGNA / EMILIA ROMAGNA
   - BOLOGNA NAVILE, 40128 BOLOGNA / EMILIA ROMAGNA
   - BOLZANO, 39100 BOLZANO / TRENTINO ALTO ADIGE
   - BORGO SAN DALMAZZO, 12011 BORGO SAN DALMAZZO / PIEMONTE
   - BRESCIA RONCADELLE, 25030 RONCADELLE / LOMBARDIA
   - BUSSOLENGO, 37012 BUSSOLENGO / VENETO
   - CAGLIARI - QUARTUCCIU, 09044 QUARTUCCIU / SARDEGNA
   - CAGLIARI LA PLAIA, 09123 CAGLIARI / SARDEGNA
   - CAIRO MONTENOTTE, 17014 CAIRO MONTENOTTE / LIGURIA
   - CAMPOBASSO, 86100 CAMPOBASSO / MOLISE
   - CAMPOROSSO, 18033 CAMPOROSSO / LIGURIA
   - CANTÙ, 22063 CANTU' / LOMBARDIA
   - CARINI , 90044 CARINI / SICILIA
   - CARPI, 41012 CARPI / EMILIA ROMAGNA
   - CASALE MONFERRATO, 15033 CASALE MONFERRATO / PIEMONTE
   - CASALECCHIO DI RENO, 40033 CASALECCHIO DI RENO / EMILIA ROMAGNA
   - CASTAGNITO, 12050 CASTAGNITO / PIEMONTE
   - CASTELFRANCO VENETO, 31033 CASTELFRANCO VENETO (TREVISO) / VENETO
   - CASTELLETTO TICINO, 28053 CASTELLETTO TICINO / PIEMONTE
   - CASTELMAGGIORE, 40013 CASTEL MAGGIORE / EMILIA ROMAGNA
   - CASTENASO NEW, 40055 CASTENASO / EMILIA ROMAGNA
   - CASTENEDOLO , 25014 CASTENEDOLO / LOMBARDIA
   - CATANIA ETNAPOLIS, 95032 BELPASSO / SICILIA
   - CATANIA I PORTALI, 95037 SAN GIOVANNI LA PUNTA / SICILIA
   - CATANIA LA RENA, 95121 CATANIA / SICILIA
   - CATANIA PORTE DI CATANIA, 95121 Catania / SICILIA
   - CENTO, 44042 CENTO / EMILIA ROMAGNA
   - CESANO BOSCONE, 20090 CESANO BOSCONE / LOMBARDIA
   - CESENA, 47023 CESENA / EMILIA ROMAGNA
   - CHIANOCCO, 10050 CHIANOCCO / PIEMONTE
   - CHIAVARI, 16043 CHIAVARI / LIGURIA
   - CIAMPINO, 00043 CIAMPINO / LAZIO
   - CISANO SUL NEVA, 17035 CISANO SUL NEVA / LIGURIA
   - CISTERNA DI LATINA, 04012 CISTERNA DI LATINA / LAZIO
   - CIVITANOVA, 62012 CIVITANOVA MARCHE / MARCHE
   - COLLEFERRO, 00034 COLLEFERRO / LAZIO
   - COLLEGNO, 10093 COLLEGNO / PIEMONTE
   - COMACCHIO , 44022 COMACCHIO / EMILIA ROMAGNA
   - COMO EXPERT SRL, 22100 COMO / LOMBARDIA
   - CONEGLIANO, 31015 CONEGLIANO  / VENETO
   - CREMONA, 26100 CREMONA / LOMBARDIA
   - CURNO, 24035 CURNO / LOMBARDIA
   - CURTATONE, 46010 CURTATONE / LOMBARDIA
   - FABRIANO, 60044 FABRIANO / MARCHE
   - FAENZA, 48018 FAENZA / EMILIA ROMAGNA
   - FANO, 61032 FANO / MARCHE
   - FELTRE, 32032 FELTRE  / VENETO
   - FERMO, 63023 FERMO / MARCHE
   - FERRARA, 44124 FERRARA / EMILIA ROMAGNA
   - FINIPER ARESE, 20020 ARESE / LOMBARDIA
   - FINIPER BREMBATE, 24041 BREMBATE / LOMBARDIA
   - FINIPER BUSNAGO, 20874 BUSNAGO / LOMBARDIA
   - FINIPER CASTELFRANCO VENETO , 31033 CASTELFRANCO VENETO  / VENETO
   - FINIPER CREMONA , 26030 GADESCO PIEVE DELMONA  / LOMBARDIA
   - FINIPER GRANDATE, 22070 GRANDATE / LOMBARDIA
   - FINIPER LONATO DEL GARDA, 25017 LONATO / LOMBARDIA
   - FINIPER MAGENTA, 20013 MAGENTA / LOMBARDIA
   - FINIPER MILANO PORTELLO, 20149 MILANO / LOMBARDIA
   - FINIPER MONTEBELLO , 27054 MONTEBELLO DELLA BATTAGLIA  / LOMBARDIA
   - FINIPER MONZA, 20900 MONZA / LOMBARDIA
   - FINIPER ORIO AL SERIO, 24050 ORIO AL SERIO / LOMBARDIA
   - FINIPER ROZZANO, 20089 ROZZANO / LOMBARDIA
   - FINIPER SAVIGNANO SUL RUBICONE, 47039 SAVIGNANO SUL RUBICONE  / EMILIA ROMAGNA
   - FINIPER SERIATE, 24068 SERIATE / LOMBARDIA
   - FINIPER SERRAVALLE SCRIVIA, 15069 SERRAVALLE SCRIVIA  / PIEMONTE
   - FINIPER SOLBIATE, 21058 SOLBIATE OLONA / LOMBARDIA
   - FINIPER TORTONA, 15057 TORTONA  / PIEMONTE
   - FINIPER VARESE, 21100 VARESE / LOMBARDIA
   - FINIPER VERONA LE CORTI VENETE , 37036 SAN MARTINO BUON ALBERGO  / VENETO
   - FINIPER VITTUONE, 20010 VITTUONE / LOMBARDIA
   - FIUME VENETO, 33080 FIUME VENETO (PORDENONE) / FRIULI VENEZIA GIULIA
   - FIUMICINO PARCO LEONARDO, 00054 FIUMICINO / LAZIO
   - FORLÌ , 47122 FORLI' / EMILIA ROMAGNA
   - FORLÌ MEGA, 47121 FORLI' / EMILIA ROMAGNA
   - FORMIA, 04023 FORMIA / LAZIO
   - FROSINONE, 03100 FROSINONE / LAZIO
   - FUENTES, 22010 GERA LARIO / LOMBARDIA
   - GAGLIANICO, 13894 GAGLIANICO / PIEMONTE
   - GALLARATE , 21013 GALLARATE / LOMBARDIA
   - GALLIERA, 35015 GALLIERA / VENETO
   - GELA, 93012 GELA / SICILIA
   - GENOLA, 12040 GENOLA / PIEMONTE
   - GENOVA 2 - P.ZZA VITTORIA, 16121 GENOVA / LIGURIA
   - GENOVA 3 - CAMPI, 16152 GENOVA / LIGURIA
   - GENOVA MARASSI, 16139 GENOVA / LIGURIA
   - GERMIGNAGA , 21010 GERMIGNAGA / LOMBARDIA
   - GIACCIANO CON BARUCHELLA, 45020 GIACCIANO IN BARRUCHELLA / VENETO
   - GIUGLIANO GRANDE SUD, 80014 Giugliano / CAMPANIA
   - GRAVELLONA TOCE , 28883 GRAVELLONA TOCE / PIEMONTE
   - GROSSETO, 58100 GROSSETO / TOSCANA
   - IMPERIA - SASA, 18100 IMPERIA / LIGURIA
   - ISERNIA, 86170 ISERNIA / MOLISE
   - IVREA - BUROLO, 10010 BUROLO D'IVREA / PIEMONTE
   - JESI, 60035 JESI / MARCHE
   - JESOLO, 30016 JESOLO / VENETO
   - LA SPEZIA, 19126 LA SPEZIA / LIGURIA
   - LAMEZIA, 88043 FEROLETO ANTICO / CALABRIA
   - LANCIANO, 66034 LANCIANO / ABRUZZO
   - LATINA, 04100 LATINA / LAZIO
   - LATINA FIORI 2, 04100 LATINA / LAZIO
   - LECCE, 73100 LECCE / PUGLIA
   - LECCE (CAVALLINO), 73020 CAVALLINO / PUGLIA
   - LEGNANO , 20025 LEGNANO / LOMBARDIA
   - LEGNANO - CERRO MAGG., 20023 CERRO MAGGIORE / LOMBARDIA
   - LIMBIATE, 20812 LIMBIATE / LOMBARDIA
   - LISSONE , 20851 LISSONE / LOMBARDIA
   - LIVORNO, 57121 LIVORNO / TOSCANA
   - LIVORNO 2, 57121 LIVORNO / TOSCANA
   - LORETO , 60025 LORETO / MARCHE
   - LUGO, 48022 LUGO / EMILIA ROMAGNA
   - MACERATA, 62100 MACERATA / MARCHE
   - MAGLIE, 70124 MAGLIE / PUGLIA
   - MARINA DI MASSA, 58024 MARINA DI MASSA / TOSCANA
   - MARSALA, 91025 MARSALA / SICILIA
   - MATERA, 75100 MATERA / BASILICATA
   - MAZARA DEL VALLO, 91026 MAZARA DEL VALLO / SICILIA
   - MEDA CENTER SRL, 20821 MEDA / LOMBARDIA
   - MEGLIADINO, 35040 BORGO VENETO LOCALITÀ MEGLIADINO SAN FIDENZIO / VENETO
   - MELFI, 85025 MELFI / BASILICATA
   - MERANO, 39022 LAGUNDO / TRENTINO ALTO ADIGE
   - MERATE, 23807 MERATE / LOMBARDIA
   - MESSINA TREMESTIERI, 98122 Tremestieri / SICILIA
   - MESTRE, 30174 MESTRE / VENETO
   - MILANO ADRIANO, 20128 MILANO / LOMBARDIA
   - MILANO BICOCCA, 20125 MILANO / LOMBARDIA
   - MILANO CANONICA, 20154 MILANO / LOMBARDIA
   - MILANO MARGHERA, 20149 MILANO / LOMBARDIA
   - MILANO RINASCENTE, 20121 MILANO / LOMBARDIA
   - MILANO SAN BABILA, 20122 MILANO / LOMBARDIA
   - MILANO STELVIO, 20159 MILANO / LOMBARDIA
   - MIRANDOLA, 41037 MIRANDOLA / EMILIA ROMAGNA
   - MISANO ADRIATICO, 47843 MISANO ADRIATICO / EMILIA ROMAGNA
   - MISTERBIANCO, 95045 MISTERBIANCO / SICILIA
   - MODENA, 41125 MODENA / EMILIA ROMAGNA
   - MODICA, 97015 MODICA / SICILIA
   - MONCALIERI, 10024 MONCALIERI / PIEMONTE
   - MONDOVI', 12084 MONDOVI' / PIEMONTE
   - MONFALCONE, 34074 MONFALCONE / FRIULI VENEZIA GIULIA
   - MONSELICE, 35138 MONSELICE / VENETO
   - MUGGIA, 34015 MUGGIA / FRIULI VENEZIA GIULIA
   - NARDO', 72100 NARDO' / PUGLIA
   - NETTUNO, 00048 NETTUNO / LAZIO
   - NOVARA, 28100 NOVARA / PIEMONTE
   - NOVARA VEVERI, 28100 NOVARA / PIEMONTE
   - ODERZO, 31046 ODERZO / VENETO
   - OLBIA, 07026 OLBIA / SARDEGNA
   - OLGIATE OLONA, 21057 OLGIATE OLONA / LOMBARDIA
   - ORIO, 24050 AZZANO SAN PAOLO / LOMBARDIA
   - ORISTANO, 09170 ORISTANO / SARDEGNA
   - PADERNO DUGNANO, 20037 PEDERNO DUGNANO / LOMBARDIA
   - PADOVA, 35131 PADOVA / VENETO
   - PAESE, 31038 PAESE / VENETO
   - PALERMO CC AI LEONI, 90135 PALERMO / SICILIA
   - PALERMO CC GUADAGNA, 90124 PALERMO / SICILIA
   - PALERMO CONCA D'ORO, 90146 Palermo  / SICILIA
   - PALERMO LA MALFA CC NUOVA CITTÀ MERCATO, 90146 PALERMO / SICILIA
   - PALERMO LA TORRE, 90135 PALERMO / SICILIA
   - PARMA CENTRO TORRI, 43122 PARMA / EMILIA ROMAGNA
   - PARMA EUROSIA, 43023 PARMA / EMILIA ROMAGNA
   - PAVIA, 27028 SAN MARTINO SICCOMARIO / LOMBARDIA
   - PEDEROBBA , 31040 PEDEROBBA / VENETO
   - PERGINE VALSUGANA, 38057 PERGINE VALSUGANA (TRENTO) / TRENTINO ALTO ADIGE
   - PERUGIA, 06129 PERUGIA / UMBRIA
   - PERUGIA - OLMO, 06132 PERUGIA / UMBRIA
   - PESARO, 61100 PESARO / MARCHE
   - PESCARA SAN GIOVANNI TEATINO, 66020 SAN GIOVANNI TEATINO / ABRUZZO
   - PIACENZA, 29100 PIACENZA / EMILIA ROMAGNA
   - PIEDIMONTE SAN GERMANO, 03030 PIEDIMONTE SAN GERMANO / LAZIO
   - PINEROLO, 10064 PINEROLO / PIEMONTE
   - PINO TORINESE, 10025 PINO TORINESE / PIEMONTE
   - PIOVE DI SACCO, 35138 PIOVE DI SACCO / VENETO
   - PISA, 56100 PISA / TOSCANA
   - POMEZIA, 00040 POMEZIA / LAZIO
   - PORTOGRUARO, 30026 PORTOGRUARO / VENETO
   - POTENZA, 85100 POTENZA / BASILICATA
   - PRATO, 59100 PRATO / TOSCANA
   - PRATO TARGETTI, 59100 PRATO / TOSCANA
   - RAGUSA, 97100 RAGUSA / SICILIA
   - RAVENNA, 48100 RAVENNA / EMILIA ROMAGNA
   - REGGIO EMILIA, 42100 REGGIO EMILIA / EMILIA ROMAGNA
   - RESCALDINA, 20027 RESCALDINA / LOMBARDIA
   - RIMINI, 47900 RIMINI / EMILIA ROMAGNA
   - RIVALTA, 10040 RIVALTA / PIEMONTE
   - ROMA 1 (MURATELLA), 00148 ROMA / LAZIO
   - ROMA 2, 00131 ROMA / LAZIO
   - ROMA 4 SETTEBAGNI, 00138 ROMA / LAZIO
   - ROMA 5 BOCCEA, 00168 ROMA / LAZIO
   - ROMA CASETTA MATTEI, 00148 ROMA / LAZIO
   - ROMA EUROMA2, 00144 ROMA / LAZIO
   - ROMA MARCONI, 00146 ROMA / LAZIO
   - ROMA PORTA DI ROMA, 00139 Roma / LAZIO
   - ROMA PRENESTINA, 00155 ROMA / LAZIO
   - ROMA TRASTEVERE, 00153 ROMA / LAZIO
   - ROMAGNANO SESIA , 28078 ROMAGNANO SESIA / PIEMONTE
   - ROSÀ, 36027 ROSA' / VENETO
   - ROVIGO, 35026 ROVIGO / VENETO
   - SACCHI GIUSEPPE SPA PV. BARZANÒ, 23891 BARZANO' / LOMBARDIA
   - SALUZZO, 12037 SALUZZO / PIEMONTE
   - SAN BENEDETTO PORTOGRANDE, 63074 PORTO D'ASCOLI / MARCHE
   - SAN GIORGIO DELLE PERTICHE, 35010 SAN GIORGIO DELLE PERTICHE (PADOVA) / VENETO
   - SAN GIULIANO MILANESE , 20098 SAN GIULIANO MILANESE / LOMBARDIA
   - SAN PIETRO DI LEGNAGO, 37045 SAN PIETRO DI LEGNAGO / VENETO
   - SASSARI, 07100 SASSARI / SARDEGNA
   - SAVONA, 17100 SAVONA / LIGURIA
   - SCHIO, 36015 SCHIO / VENETO
   - SCURCOLA MARSICANA (AVEZZANO), 67068 SCURCOLA MARSICANA / ABRUZZO
   - SELVAZZANO, 35030 SELVAZZANO DENTRO / VENETO
   - SENIGALLIA, 60019 SENIGALLIA / MARCHE
   - SERRAVALLE SCRIVIA, 15069 NOVI LIGURE / PIEMONTE
   - SESTO FIORENTINO , 50019 SESTO FIORENTINO / TOSCANA
   - SETTIMO MILANESE, 20019 SETTIMO MILANESE / LOMBARDIA
   - SIENA, 53100 SIENA / TOSCANA
   - SILEA, 31057 SILEA / VENETO
   - SILVI MARINA, 64028 SILVI MARINA / ABRUZZO
   - SIRACUSA MELILLI BELVEDERE, 96010 Città Giardino  / SICILIA
   - SOAVE, 36016 SOAVE / VENETO
   - SOMMA LOMBARDO, 21019 SOMMA LOMBARDO / LOMBARDIA
   - SONDRIO - CASTIONE AND., 23012 CASTIONE ANDEVENNO / LOMBARDIA
   - SORA, 03039 SORA / LAZIO
   - SURANO, 73030 SURANO / PUGLIA
   - TARANTO, 74121 TARANTO / PUGLIA
   - TERMOLI, 86039 TERMOLI / MOLISE
   - TERNI, 5100 TERNI / UMBRIA
   - THIENE, 36016 THIENE / VENETO
   - TOLENTINO, 62029 TOLENTINO / MARCHE
   - TORINO 1 VANDALINO, 10142 TORINO / PIEMONTE
   - TORINO 2 CANELLI, 10127 TORINO / PIEMONTE
   - TORINO 3 SETTIMO T.SE, 10154 SETTIMO TORINESE / PIEMONTE
   - TORINO CORSO VIGEVANO, 10155 TORINO / PIEMONTE
   - TORINO ORBETELLO, 10148 TORINO / PIEMONTE
   - TORINO STAZIONE, 10100 TORINO / PIEMONTE
   - TORRI DI QUARTESOLO, 36040 TORRI DI QUARTESOLO / VENETO
   - TRADATE , 23050 TRADATE / LOMBARDIA
   - TRAPANI, 91100 TRAPANI / SICILIA
   - TREBASELEGHE, 35010 TREBASELEGHE / VENETO
   - TRIESTE, 34126 TRIESTE  / FRIULI VENEZIA GIULIA
   - UDINE, 33100 TORREANO DI MARTIGNACCO / FRIULI VENEZIA GIULIA
   - UDINE TAVAGNACCO, 33010 TAVAGNACCO / FRIULI VENEZIA GIULIA
   - VALMONTONE NEW, 00038 VALMONTONE / LAZIO
   - VARESE, 21100 VARESE / LOMBARDIA
   - VELLETRI, 00049 VELLETRI / LAZIO
   - VENEZIA MARCON , 30020 MARCON  / VENETO
   - VERCELLI, 13100 VERCELLI  / PIEMONTE
   - VERONA, 37024 VERONA / VENETO
   - VERONA CAPPELLO, 37121 VERONA / VENETO
   - VIGEVANO, 27029 VIGEVANO / LOMBARDIA
   - VILLAFRANCA DI VERONA, 37069 VILLAFRANCA DI VERONA / VENETO
   - VIMODRONE, 20090 VIMODRONE / LOMBARDIA
   - VITERBO, 01100 VITERBO / LAZIO

   Puoi anche applicare sul Unieuro website o app.`,
  faq_topic_1_q5: "Quali sono i termini dell'offerta permuta?",
  faq_topic_1_a5:
    'Quando acquisti un prodotto Dyson idoneo e lo permuti con un vecchio aspirapolvere, riceverai un pagamento sul conto bancario fornito in fase di registrazione.\n\nPuoi leggere i termini e condizioni completi cliccando la sezione dedicata in fondo alla questa pagina.',
  faq_topic_1_q6: 'Devo vivere in Italia per partecipare a questo programma?',
  faq_topic_1_a6:
    "No, ma devi essere in grado spedirci tramite etichetta prepagata o di portare il dispositivo che desideri permutare presso uno dei punti di consegna designati in Italia ed avere un conto bancario in Italia o in un altro paese SEE per partecipare all'evento di permuta.",
  faq_topic_1_q7: 'Quali dati servono per compilare il modulo?',
  faq_topic_1_a7:
    "Per ricevere il pagamento devi fornirci il tuo nome completo, il numero di serie del nuovo prodotto Dyson acquistato, la ricevuta di acquisto, la marca dell'aspirapolvere permutato, il tuo indirizzo e il tuo IBAN.",
  faq_topic_1_q8: 'Cosa succede se ho perso la ricevuta di acquisto del mio nuovo Dyson?',
  faq_topic_1_a8:
    'Devi richiedere una nuova ricevuta al tuo rivenditore. Senza la ricevuta non possiamo elaborare la tua richiesta di permuta. ',
  faq_topic_1_q9: "Chi gestisce l'evento Trade In Dyson?",
  faq_topic_1_a9:
    "L'evento di permuta è gestito per conto di Unieuro da [Alchemy](https://www.alchemyglobalsolutions.com), un leader globale nell’economia circolare e nel mercato del trade-in.",
  faq_topic_1_q10: 'Cosa succede dopo aver presentato la richiesta di permuta?',
  faq_topic_1_a10: "Riceverai un'email di conferma con il numero di riferimento.",
  faq_topic_1_q11: "Qual è il tempo necessario per l'elaborazione della mia richiesta di permuta?",
  faq_topic_1_a11:
    "La tua richiesta verrà presa in carico e riceverai la conferma di elaborazione entro 1 giorno lavorativo (lunedì-venerdì).\n\nDopo l'approvazione della tua richiesta ti verrà inviata un'email con un'etichetta di spedizione prepagata che dovrai stampare e incollare sulla scatola del vecchio prodotto da restituire.",
  faq_topic_1_q12:
    "Chi posso contattare se non ho ricevuto un'email di conferma oppure se la mia richiesta non è stata approvata?",
  faq_topic_1_a12:
    'Puoi contattare il team del servizio clienti di Alchemy scrivendo a [dyson@alchemyglobalsolutions.com](mailto:dyson@alchemyglobalsolutions.com).',
  // -------------------------------------
  // Shipping Section
  // -------------------------------------
  faq_topic_2_title: 'Imballaggio e spedizione del tuo vecchio aspirapolvere',
  faq_topic_2_q1: 'Come imballare il mio vecchio aspirapolvere?',
  faq_topic_2_a1:
    "Per inviarci il tuo vecchio prodotto dovrai utilizzare una scatola adatta. Il prodotto deve essere imballato in modo sicuro e senza spazio eccessivo nella scatola. Utilizza una scatola della dimensione giusta. Incolla l'etichetta di spedizione prepagata sulla scatola.",
  faq_topic_2_q2: 'Posso utilizzare qualsiasi tipo di scatola?',
  faq_topic_2_a2:
    "Sì, qualsiasi scatola di cartone è adatta. Puoi anche usare la scatola originale dell'aspirapolvere.",
  faq_topic_2_q3: 'Cosa devo mettere nella scatola ella scatola?',
  faq_topic_2_a3:
    "* Il tuo vecchio aspirapolvere da permutare, integro e funzionante.\n\n* Deve essere un aspirapolvere di dimensioni normali, alimentato con cavo o batteria.\n\n* Assicurati che il contenitore o il sacchetto per la raccolta della polvere sia vuoto.\n\n* Non è necessario inviare tubi, cavi, batterie o altri accessori. Solo l'unità principale (compresa di motore).",
  faq_topic_2_q4: 'Come posso spedire le batterie?',
  faq_topic_2_a4:
    "* Se il dispositivo è dotato di batteria e desideri inviarla, deve essere integra e priva di danni fisici.\n\n* Non inviarci delle batterie danneggiate.\n\n* Non utilizzare un'etichetta per merci pericolose, la spedizione di una singola batteria non la richiede.",
  faq_topic_2_q5: 'Come posso spedire la scatola?',
  faq_topic_2_a5:
    "* Assicurati che la scatola sia sigillata e sicura, con l'etichetta stampata incollata.\n\n* Consegna il pacco in un centro di consegna DHL o organizza il ritiro dal tuo indirizzo tramite corriere DHL. DHL è l'unico corriere con cui sarà possibile inviare il pacco.",
  // -------------------------------------
  // After Shipping Section
  // -------------------------------------
  faq_topic_3_title: 'Dopo aver permutato il mio prodotto',
  faq_topic_3_q1: 'Come posso sapere se il mio vecchio aspirapolvere è stato ricevuto?',
  faq_topic_3_a1: "Appena ricevuto il tuo prodotto ti invieremo un'email di conferma con l'importo del rimborso.",
  faq_topic_3_q2: "In quanto tempo verrà inviata la conferma di ricezione dell'aspirapolvere?",
  faq_topic_3_a2:
    'Ti confermeremo le ricezione del tuo vecchio aspirapolvere via e.mail entro 7 giorni dalla spedizione.',
  faq_topic_3_q3: 'Cosa succede se il mio vecchio aspirapolvere non viene considerato adatto al rimborso?',
  faq_topic_3_a3:
    "Nel caso in cui l'aspirapolvere spedito non corrisponda a quanto dichiarato nella permuta, il nostro servizio clienti ti contatterà immediatamente.",
  faq_topic_3_q4: 'Quanto tempo occorrerà per ricevere il rimborso relativo alla permuta?',
  faq_topic_3_a4:
    "Una volta confermato l'acquisto di un aspirapolvere Dyson idoneo e la ricezione della permuta, il rimborso sarà inviato sul conto bancario indicato entro 30/45 giorni.",
  // -------------------------------------
  // General Section
  // -------------------------------------
  faq_topic_4_title: 'Domande generali',
  faq_topic_4_q1: "Come posso contattare il servizio clienti per l'offerta di permuta?",
  faq_topic_4_a1:
    "Se hai domande sulla permuta o su come compilare la richiesta, puoi contattare il team Alchemy all'indirizzo email [dyson@alchemyglobalsolutions.com](mailto:dyson@alchemyglobalsolutions.com).",
  faq_topic_4_q2: 'Quali sono gli orari del servizio clienti?',
  faq_topic_4_a2:
    'Siamo disponibili nei giorni feriali dalle 9:00 alle 17:00, risponderemo a tutte le domande entro un giorno lavorativo al massimo.',
  /** -------------------------------------------------------------------------- *
   * Quiz
   * -------------------------------------------------------------------------- */
  // -------------------------------------
  // Customer Section
  // -------------------------------------
  quiz_s1_title: 'I tuoi dettagli',
  quiz_s1_intro:
    'Ti contatteremo per confermare quando il prodotto scambiato è stato ricevuto e il tuo pagamento sarà elaborato.',
  quiz_s1_q1_label: 'Nome e cognome',
  quiz_s1_q1_placeholder: 'Nome completo',
  quiz_s1_q1_error_required: 'Fornisci il tuo nome completo',
  quiz_s1_q1_error_invalid: 'Per favore inserisci il tuo nome e il tuo cognome',
  quiz_s1_q2_label: 'Indirizzo email.',
  quiz_s1_q2_placeholder: 'nome@sito.it',
  quiz_s1_q2_error_required: 'Inserisci il tuo indirizzo email',
  quiz_s1_q2_error_invalid: 'Si prega di inserire un indirizzo email valido',
  quiz_s1_button: 'Continua',
  quiz_s1_button_hint: 'Si prega di completare tutti i campi prima di continuare',
  // -------------------------------------
  // Purchase Section
  // -------------------------------------
  quiz_s2_title: 'Verifica il tuo acquisto recente',
  quiz_s2_short_title: "Verifica l'acquisto",
  quiz_s2_intro:
    "Possiamo accettare una permuta di aspirapolvere solo se hai acquistato un aspirapolvere idoneo da Unieuro nei tempi previsti dalla promozione. Assicurati che la data di acquisto, l'oggetto acquistato e il commerciante siano visibili.",
  quiz_s2_next_step: 'Passi successivo: Aspirapolvere Trade In',
  quiz_s2_button: 'Verifica',
  quiz_s2_q1_label: 'Quale modello hai acquistato?',
  // -------------------------------------
  quiz_s2_serial_title: 'Il tuo numero di serie',
  quiz_s2_serial_help_button: 'Dove lo posso trovare',
  quiz_s2_serial_q1_label: 'Carica la foto di un numero di serie',
  quiz_s2_serial_q1_placeholder: "Carica un'immagine • Max 10MB",
  quiz_s2_serial_q2_label: 'Numero di serie',
  quiz_s2_serial_q2_placeholder: '000-00-00000000',
  quiz_s2_serial_q2_error_required: 'Inserisci un numero di serie',
  quiz_s2_serial_q2_error_schema: 'Si prega di inserire un numero di serie valido',
  quiz_s2_serial_q2_error_maxlength: 'Sono consentiti al massimo 15 caratteri',
  // -------------------------------------
  quiz_s2_receipt_title: 'La tua ricevuta',
  quiz_s2_receipt_q1_label: 'Carica immagine della ricevuta',
  quiz_s2_receipt_q1_placeholder: 'Carica immagine Max 10MB',
  quiz_s2_receipt_q2_label: 'Data di acquisto',
  quiz_s2_receipt_q2_placeholder: 'GG / MM / AAAA',
  quiz_s2_receipt_q2_error_required: 'Inserisi la data',
  quiz_s2_receipt_q2_error_invalid: 'Deve essere una data valida',
  quiz_s2_receipt_q2_error_length: 'Deve essere una data valida',
  quiz_s2_receipt_q2_error_future: 'La data non può essere futura',
  quiz_s2_receipt_q2_error_range: "La data d'acquisto deve essere compresa tra il 22/04/2024 e il 19/05/2024",
  quiz_s2_receipt_q3_label: 'Rivenditore',
  quiz_s2_receipt_q3_placeholder: 'Seleziona',
  quiz_s2_receipt_q3_error_required: 'Seleziona Unieuro Punto Vendita',
  // -------------------------------------
  quiz_s2_file_error_required: 'Devi caricare un file',
  quiz_s2_file_error_size: 'File troppo grande',
  quiz_s2_file_error_format: 'Formato file non supportato',
  quiz_s2_file_error_invalid: 'Immagine non valida',
  quiz_s2_file_error_processing: "Errore nell'elaborazione dell'immagine",
  quiz_s2_file_select: 'Seleziona immagine',
  // -------------------------------------
  serial_under_battery_title: 'Sul lato inferiore della batteria',
  serial_under_battery_desc: "Il numero di serie è stampato sul retro della batteria alla base dell'impugnatura",
  serial_behind_bin_title: 'Dietro il cestino trasparente',
  serial_behind_bin_desc:
    'Guarda sul lato inferiore del contenitore trasparente di fronte al grilletto per rivelare il numero di serie',
  serial_inside_handle_title: "All'interno della maniglia",
  serial_inside_handle_desc:
    "Rimuovi la batteria a scatto per rivelare il numero di serie all'interno dell'impugnatura della macchina",
  serial_helper_exit_button: 'Chiudi',
  // -------------------------------------
  // Trade-in Section
  // -------------------------------------
  quiz_s3_title: 'Il tuo aspirapolvere da permutare',
  quiz_s3_short_title: 'Valutazione della permuta',
  quiz_s3_intro: 'Parlaci del prodotto che vuoi permutare e ti diremo il suo valore',
  quiz_s3_next_step: 'Passi successivi: Indirizzo di contatto',
  quiz_s3_button: 'Controlla il valore',
  // -------------------------------------
  tradein_q1_label: 'Chi è il produttore?',
  tradein_q1_option_1: 'Dyson',
  tradein_q1_option_2: 'Altro',
  tradein_serial_label: 'Quale il numero di serie (opzionale)',
  tradein_serial_hint: '',
  tradein_q2_label: 'Conferma dei termini di permuta Dyson',
  tradein_q2_answer: "Sono d'accordo che la mia permuta soddisfa i",
  tradein_q2_link: 'condizioni del programma',
  tradein_q2_term_1: 'Il mio aspirapolvere è intero e funzionante',
  tradein_q2_term_2: 'Il mio aspirapolvere è un aspirapolvere di dimensione normale alimentato a batteria o con cavo',
  tradein_q2_term_3: 'Il contenitore o Il sacchetto per la raccolta della polvere è vuoto',
  tradein_q2_term_4: 'Sto inviando un aspirapolvere adatto',
  // -------------------------------------
  valuation_title: 'Il valore del tuo aspirapolvere è',
  valuation_desc_1:
    'Ti pagheremo tra 30 e 45 giorni dopo aver ricevuto il tuo prodotto in permuta presso la nostra struttura.',
  valuation_desc_2: 'Le discrepanze tra ciò che descrivi e ciò che riceviamo, potrebbero influenzare la valutazione.',
  valuation_button: 'Continua',
  // -------------------------------------
  // Shipping Section
  // -------------------------------------
  shipping_title: 'Indirizzo',
  shipping_short_title: 'Indirizzo',
  shipping_intro: "Abbiamo bisogno di conoscere il tuo indirizzo per poter generare l'etiquetta di ritiro.",
  shipping_next_step: 'Passi successivi: Dettagli di pagamento',
  shipping_button: 'Continua',
  shipping_q1_label: 'Cerca il tuo indirizzo',
  shipping_q1_placeholder: 'Inizia a digitare un indirizzo',
  shipping_address_label: 'Indirizzo della strada',
  shipping_address_placeholder: '',
  shipping_address_error_required: 'Inserisci un indirizzo della strada',
  shipping_city_label: 'Città',
  shipping_city_placeholder: '',
  shipping_city_error_required: 'Inserisci città',
  shipping_postcode_label: 'Codice postale',
  shipping_postcode_placeholder: '',
  shipping_postcode_error_required: 'Inserisci il codice postale',
  shipping_postcode_error_invalid: 'Il codice postale deve contenere da 3 a 10 caratteri',
  shipping_country_label: 'Paese',
  shipping_country_placeholder: 'Seleziona',
  shipping_country_error_required: 'Seleziona il paese',
  shipping_matched_address: 'Il tuo indirizzo',
  shipping_no_address_match: 'Non vedi il tuo indirizzo? Aggiungilo manualmente.',
  shipping_back_button: 'Torna',
  // -------------------------------------
  // Payment Section
  // -------------------------------------
  payment_title: 'Dettagli di pagamento',
  payment_short_title: 'Dettagli di pagamento',
  payment_intro:
    'Forniscici le coordinate bancarie del conto sul quale desideri che effettuiamo il pagamento. Si prega di controllare attentamente queste informazioni poiché non possiamo essere responsabili per eventuali errori.',
  payment_next_step: 'Passi finali',
  // -------------------------------------
  payment_account_label: 'Titolare del conto',
  payment_account_placeholder: 'Nome completo del titolare del conto',
  payment_account_error_required: 'Inserisi il nome completo del titolare del conto',
  payment_account_error_invalid: 'Inserisi il nome completo',
  // -------------------------------------
  payment_iban_label: 'IBAN',
  payment_iban_placeholder: 'e.g. IT00 0000 0000 0000 0000 0000 000',
  payment_iban_error_required: 'Inserisi il tuo IBAN',
  payment_iban_error_invalid: 'Si prega di inserire il tuo IBAN valido',
  // -------------------------------------
  payment_submit_button: 'Invia',
  payment_submit_hint: 'Si prega di completare tutti i campi prima di inviare',
  // -------------------------------------
  payment_terms_text_1: 'Ho letto e accettato i',
  payment_terms_link_1: 'Termini e Condizioni,',
  payment_terms_text_2: 'e',
  payment_terms_link_2: 'politica sulla riservatezza',
  payment_terms_text_3: ' ',
  payment_terms_error_required: 'Accetta termini e condizioni.',
  // -------------------------------------
  confirm_title: 'Conferma i dettagli di pagamento',
  confirm_desc: 'Assicurati che i dettagli di pagamento che hai inserito siano validi.',
  confirm_account_label: 'Titolare del conto',
  confirm_iban_label: 'IBAN',
  confirm_button: 'Conferma',
  confirm_back_button: 'Torna',

  // -------------------------------------
  // Order Confirmation Section
  // -------------------------------------
  order_title_1: 'Grazie',
  order_title_2: 'la tua permuta è stata creata!',
  order_confirmation_title: 'Quali sono i passaggi successivi?',
  order_confirmation_step1_title: 'Controllo dati inseriti',
  order_confirmation_step1_content:
    'Dobbiamo effettuare alcuni controlli finali sui dettagli che ci hai fornito, ma non preoccuparti, questo è previsto e non dovrebbe richiedere più di 1 giorno lavorativo. Se per qualche motivo abbiamo bisogno di ulteriori informazioni per completare i nostri controlli, ti contatteremo via email.',
  order_confirmation_step2_title: 'Imballa il tuo vecchio aspirapolvere da permutare e spediscilo',
  order_confirmation_step2_content:
    "Ti invieremo un'email con la tua etichetta di spedizione gratuita all'indirizzo che hai fornito.\n\n Quando la ricevi, imballa il tuo aspirapolvere in permuta in una scatola adatta e attacca la tua etichetta. Le istruzioni per la spedizione saranno incluse nell'email.",
  order_confirmation_step3_title: 'Ricevi il pagamento',
  order_confirmation_step3_contentA:
    'Appena ricevuto il tuo aspirapolvere verrà ispezionato, se è come descritto, effettueremo un pagamento sul conto bancario fornito. Il rimborso verrà effettuato da 30 a 45 giorni dopo la ricezione del prodotto.',
  order_confirmation_step3_contentB:
    'Appena ricevuto il tuo aspirapolvere verrà ispezionato, se è come descritto, effettueremo un pagamento sul conto bancario fornito. Il rimborso verrà effettuato da 30 a 45 giorni dopo la ricezione del prodotto.',
  order_confirmation_step3_contentC: 'Titolare del conto',
  order_confirmation_step3_contentD: 'Il pagamento verrà effettuato da 30 a 45 giorni dopo aver ricevuto il prodotto.',
  /** -------------------------------------------------------------------------- *
   * Errors
   * -------------------------------------------------------------------------- */
  server_error_Z6S:
    "Non è stato possibile creare l'ordine perché il numero di serie è già stato registrato. Si prega di contattare l'assistenza clienti.",
  /** -------------------------------------------------------------------------- *
   * Cookie Consent
   * -------------------------------------------------------------------------- */
  cookie_statement: `Cliccando su 'Accetta tutti i cookie', accetti la memorizzazione dei cookie sul tuo dispositivo per migliorare la navigazione del sito, analizzare l'utilizzo del sito e assistere nelle nostre attività di marketing.`,
  cookie_settings_button: 'Impostazioni dei cookie',
  cookie_accept_all_button: 'Accetta tutti i cookie',
  cookie_allow_selected: 'Accetta i cookie selezionati',
  cookie_allow_all: 'Accetta tutti i cookie',
  cookie_essential_title: 'Essential',
  cookie_essential_desc:
    "Questi cookie sono necessari per il funzionamento del sito web e non possono essere disattivati ​​nei vostri sistemi. In genere, questi cookie vengono impostati solo in risposta alle azioni intraprese dall'utente che corrispondono a una richiesta di servizio, come l'impostazione delle preferenze sulla privacy, l'accesso o la compilazione di moduli. Puoi impostare il tuo browser per bloccare questi cookie o per avvisarti di questi cookie. Tuttavia, alcune aree del sito web non funzioneranno. Questi cookie non memorizzano alcun dato personale.",
  cookie_performance_title: 'Prestazione',
  cookie_performance_desc:
    'Questi cookie ci consentono di contare le visite e le fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito web. Ci aiutano a rispondere a domande su quali pagine sono più popolari, quali sono meno utilizzate e su come i visitatori si muovono nel sito web. Tutte le informazioni raccolte da questi cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non saremo in grado di sapere quando hai visitato il nostro sito web.',
  cookie_functional_title: 'Funzionale',
  cookie_functional_desc:
    'Questi cookie consentono al sito Web di fornire funzionalità e personalizzazione avanzate. Possono essere impostati da noi o da terze parti di cui utilizziamo i servizi sui nostri siti. Se non consenti questi cookie, alcuni o tutti questi servizi potrebbero non funzionare correttamente.',
  cookie_targetting_title: 'Targeting',
  cookie_targetting_desc:
    "Questi cookie possono essere impostati attraverso il nostro sito Web dai nostri partner pubblicitari. Potrebbero essere utilizzati da queste società per creare un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti web. Non memorizzano direttamente dati personali, ma si basano sull'identificazione univoca del tuo browser e dispositivo Internet. Se non consenti questi cookie, riceverai pubblicità meno mirata.",
  /** -------------------------------------------------------------------------- *
   * Policy Pages
   * -------------------------------------------------------------------------- */
  terms_body: terms,
  privacy_body: privacy,
  cookies_body: cookies,
}

export default it
